export const CRMZIndex = {
    FOREMOST_Z: 200,
    SECOND_Z: 100,
    THIRD_Z: 50,
};
